var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Page not found!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }